import React from "react";

// A drawn − in currentColor, the pair of PlusIcon for the cart's quantity control
const MinusIcon = ({ size = 18 }: any) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" aria-hidden="true">
    <path d="M2 9h14" />
  </svg>
);

export default MinusIcon;
